<template>
  <span class="ml-text" :class="{ 'missing-translation': !hasTranslation }" v-text="translatedText"> </span>
</template>

<script setup>
import translationService from "../composables/translationService";
</script>
<script >
export default {
  props: {
    text: [String, Object],
  },
  computed: {
    enabledLanguages() {
      return translationService.enabledLanguages ? translationService.enabledLanguages.value : [];
    },
    defaultLanguage() {
      return translationService.defaultLanguage ? translationService.defaultLanguage.value : 'en';
    },
    hasTranslation() {
      if (!this.text) {
        return true;
      }

      if (typeof this.text == "string") {
        return true;
      }

      let selectedLanguage = translationService.selectedLanguage ? translationService.selectedLanguage.value : null;

      return selectedLanguage && this.text[selectedLanguage];
    },
    availableTranslation() {
      if (typeof this.text != "object") {
        return this.text;
      }
      // return JSON.stringify(this.text);

      let defaultLanguage = translationService.defaultLanguage;

      if (defaultLanguage && this.text[defaultLanguage]) {
        return this.text[defaultLanguage];
      }

      for (let language of this.enabledLanguages) {        
        if (this.text[language]) {
          return this.text[language];
        }
      }
      
      return null;
    },
    translatedText() {      
      return translationService.translation2Text(this.text)      
    },
  }  
}
</script>
<style scoped>
.ml-text {
  width: 100%;
  flex: 1;
  display: inline-block;  
}
.ml-text.missing-translation {
  color: #999;
  font-style: italic;
}
</style>